import { getReportHash } from "@/lib/selectors";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { createFileUpload, DesignToolMetadata, fetchDesignToolData, parseApiError } from "../../lib/api/proposal-api";
import { RootState } from "../../rootReducer";

export const fetchDesignToolMetadata = createAsyncThunk<DesignToolMetadata, undefined, { state: RootState }>(
  "data/fetchDesignToolData",
  async (_arg, thunkAPI) => {
    const reportHash = getReportHash(thunkAPI.getState());

    try {
      const response = await fetchDesignToolData(reportHash);
      return response.data;
    } catch (e: any) {
      return thunkAPI.rejectWithValue(parseApiError(e));
    }
  }
);

export const createLayoutImageUpload = createAsyncThunk<any, undefined, { state: RootState }>(
  "data/createFileUpload",
  async (arg, thunkAPI) => {
    const reportHash = getReportHash(thunkAPI.getState());

    try {
      const response = await createFileUpload(reportHash, arg);
      return response.data;
    } catch (e: any) {
      return thunkAPI.rejectWithValue(parseApiError(e));
    }
  }
);
